import { Grid, Typography } from "@mui/material";
import React from "react";
import { CustomerInterface } from "../../Objects/Customer";

export interface CustomerGenderProps {
    customerData: CustomerInterface
}

const CustomerGender: React.FC<CustomerGenderProps> = ({
    customerData
}) => {
    let [gender, setGender] = React.useState("")

    React.useEffect(()=>{
        switch(customerData.ctm_gender) {
            case "male":
                setGender("男性")
                break;
            case "femail":
                setGender("女性")
                break;
            default:
                setGender("")
        }
    },[customerData.ctm_gender])
    return (
        <Grid container>
            <Grid item xs={12}>
                <Typography variant="caption" sx={{color: "#333399"}}>性別</Typography>
            </Grid>
            <Grid item>
                <Typography variant="body1">{gender}</Typography>
            </Grid>
        </Grid>
    );
}

export default CustomerGender